import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DepositNotes } from "@app/models/deposit-notes";
import { DepositNotesService } from "@app/services/deposit-notes.service";

@Component({
    selector: "app-select-deposit-note-popup",
    templateUrl: "./select-deposit-note-popup.component.html",
    styleUrls: ["./select-deposit-note-popup.component.css"],
    standalone: false
})
export class SelectDepositNotePopupComponent implements OnInit {
  @Input() depositNotes: Array<DepositNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedDepositNotes: Array<DepositNotes>;
  @Output() onSubmit = new EventEmitter<Array<DepositNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private depositNotesService: DepositNotesService) {}

  ngOnInit() {
    if (!this.selectedDepositNotes) {
      this.selectedDepositNotes = [];
    }
    for (const root of this.depositNotes || []) for (const note of this.findAllChildren(root)) if (note.mandatory && note.status !== 'INACTIVE' && !this.selectedDepositNotes.some((selected) => selected.id === note.id)) this.selectedDepositNotes.push(note);
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(depositNote: DepositNotes) {
    if (!depositNote) {
      return;
    }
    const fullNote = this.depositNotesService.findDepositNoteById(depositNote.id, this.depositNotes) || depositNote;
    const descendants = this.findAllChildren(fullNote);
    const updated = [...this.selectedDepositNotes];
    for (const item of descendants) {
      if (!updated.some((selected) => selected.id === item.id)) {
        updated.push(item);
      }
    }
    this.selectedDepositNotes = updated;
  }

  onSave() {
    this.onSubmit.emit(this.selectedDepositNotes);
  }

  deleteSelectedDepositNote(depositNote: DepositNotes) {
    if (!depositNote) {
      return;
    }
    const fullNote = this.depositNotesService.findDepositNoteById(depositNote.id, this.depositNotes) || depositNote;
    const removeIds = new Set(this.findAllChildren(fullNote).map((item) => item.id));
    this.selectedDepositNotes = this.selectedDepositNotes.filter((item) => !removeIds.has(item.id));
  }

  checkIfParentIdInTheList(checkArray: DepositNotes[], depositNote: DepositNotes) {
    const set1 = new Set(checkArray);
    const originalDepositNote = this.depositNotesService.findDepositNoteById(depositNote.id, this.depositNotes);
    const parents = this.depositNotesService.findDepositNoteParents(originalDepositNote, this.depositNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChildren(depositNote: DepositNotes): DepositNotes[] {
    let items: DepositNotes[] = [];
    if (depositNote) {
      items.push(depositNote);
      if (depositNote.subDepositNotes && depositNote.subDepositNotes.length > 0) {
        depositNote.subDepositNotes.forEach((p) => {
          items = items.concat(this.findAllChildren(p));
        });
      }
    }
    return items;
  }
}
